import { Search } from "lucide-react";

export function SearchInput({ value, onChange, placeholder, testId }) {
  return (
    <div className="relative flex-1 min-w-[260px]">
      <Search
        size={14}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-[#141B4D]/50"
      />
      <input
        data-testid={testId}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-white border border-[#141B4D]/20 rounded-sm pl-9 pr-3 py-2 text-sm text-[#141B4D] placeholder:text-[#141B4D]/40 focus:outline-none focus:ring-2 focus:ring-[#FFD100] focus:border-[#141B4D]"
      />
    </div>
  );
}

export function FilterSelect({ value, onChange, options, placeholder, testId }) {
  return (
    <select
      data-testid={testId}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="bg-white border border-[#141B4D]/20 rounded-sm px-3 py-2 text-sm text-[#141B4D] focus:outline-none focus:ring-2 focus:ring-[#FFD100] min-w-[160px]"
    >
      <option value="">{placeholder}</option>
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
  );
}

export function MultiSelectChips({ options, selected, onToggle, testId }) {
  return (
    <div data-testid={testId} className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const active = selected.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            onClick={() => onToggle(opt)}
            data-testid={`${testId}-chip-${opt.replace(/\s+/g, "-").toLowerCase()}`}
            className={`px-2.5 py-1 rounded-sm text-xs font-medium border transition-colors ${
              active
                ? "bg-[#141B4D] text-[#F2E9DB] border-[#141B4D]"
                : "bg-white text-[#141B4D] border-[#141B4D]/20 hover:bg-[#141B4D]/5"
            }`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}

export function FilterBar({ children }) {
  return (
    <div className="flex flex-wrap items-center gap-3 mb-8 pb-6 border-b border-[#141B4D]/15">
      {children}
    </div>
  );
}
